import { Button } from "@chakra-ui/react";
import { MinusMath } from "@airhelp/icons";

interface RemoveConnectionButtonProps {
  onClick: () => void;
}

export const RemoveConnectionButton = ({ onClick }: RemoveConnectionButtonProps) => (
  <Button ml={2} justifySelf="flex-start" size="xl" variant="subtle" leftIcon={<MinusMath />} onClick={onClick} />
);
